import React from 'react';
import LeaveRequestList from './Employee/LeaveRequestList';

const LeaveRequests = () => <LeaveRequestList />;

export default LeaveRequests;
